module.exports = __webpack_public_path__ + "img/sup_withdraw_vega3.d279c750.jpg";